import React, {useEffect, useRef} from "react";
import Header from "./Header";
import {useDataContext} from "../services/data.service";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "./_core/Button";

const Layout = ({ children,
                }) => {
    const {isMenuOpen, setModalOpen, modal, modalOpen} = useDataContext();

    const modalEl = useRef(null);

    useEffect(() => {
        if (modalEl && modalEl.current) {
            const handleClickOutside = event => {
                if (!modalEl.current.contains(event.target)) {
                    setModalOpen(false);
                }
            };

            document.addEventListener("mousedown", handleClickOutside);

            return () => document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [modalEl])

    // Handle escape key to close modal
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && modalOpen) {
                setModalOpen(false);
            }
        };
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [modalOpen, setModalOpen]);

    return (
        <div className="w-full h-screen overflow-hidden flex flex-col relative">
            <Header />
            <div className={"flex items-center justify-center"} style={{height: "calc(100vh - 48px)"}}>
                {children}
            </div>
            {modalOpen && (
                <div
                    ref={modalEl}
                    className="absolute w-[28rem] top-32 mx-auto left-0 right-0 bg-white flex flex-col shadow-xl rounded-lg overflow-hidden"
                    style={{zIndex: 100}}
                >
                    <div className="px-5 py-4 flex items-center border-b border-slate-200">
                        <h3 className="text-xl text-slate-700 font-semibold flex-grow">
                            {modal ? modal.title : "Confirm"}
                        </h3>
                        <button
                            onClick={() => setModalOpen(false)}
                            className="text-slate-400 hover:text-slate-600 transition-colors p-1"
                        >
                            <FontAwesomeIcon icon={faXmark} size="lg" />
                        </button>
                    </div>
                    <div className="p-5 bg-slate-50 text-slate-600">
                        {modal ? modal.content : "Are you sure?"}
                    </div>
                    <div className="flex items-center justify-end p-4 gap-3 bg-white border-t border-slate-100">
                        <Button style="muted" onClick={() => setModalOpen(false)}>
                            Cancel
                        </Button>
                        <Button onClick={() => modal?.okButtonFn?.()}>
                            {modal?.okButtonText ?? "Confirm"}
                        </Button>
                    </div>
                </div>
            )}
            {(isMenuOpen || modalOpen) && (
                <div
                    className="absolute inset-0 top-12 bg-gray-900/30 backdrop-blur-sm transition-opacity"
                    style={{zIndex: 99}}
                />
            )}
        </div>
    )
}

export default Layout;
